import { customElement } from 'lit/decorators';
import { css, html, LitElement } from 'lit';
import { center, padding, row } from '../styles';
import CodeIcon from '@carbon/web-components/es/icons/code/16';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { annotation } from './common';


@customElement('pdq-tutorial-perspective-viewer')
class PDQTutorialPerspectiveViewer extends LitElement {
  static styles = [
    row,
    center,
    padding,
    annotation,
    css`
    `];

  render() {
    const code = `<pdq-json id="people"><template>
[
  {
    "name": "Alice",
    "age": 25
  },
  {
    "name": "Bob",
    "age": 30
  },
  {
    "name": "Charley",
    "age": 30
  }
]
</template></pdq-json>`;
    const code1 = `<pdq-perspective-viewer height="220px" table="people"></pdq-perspective-viewer>`;
    const code2 = `<pdq-perspective-viewer height="220px" table="people"><template>
{
  "group_by": [
    "age"
  ]
}
</template></pdq-perspective-viewer>`;

    return html`
      <cds-tile>

        <h2>Viewing Data</h2>
        <p>Adding data is not much use without viewing it, so let's add a
          <cds-tag type="green">${CodeIcon({ slot: 'icon' })}
            pdq-perspective-viewer
          </cds-tag>
          component to render the data
        </p>

        ${unsafeHTML(code)}

        <pdq-code-html code="${code1}"></pdq-code-html>
        ${unsafeHTML(code1)}

        <p>You can have more than one viewer for the same table. Config for the viewer can be passed directly in the
          content of the tag.</p>

        <p>So we can have a 2nd view where we group by age</p>
        <pdq-code-html code="${code2}"></pdq-code-html>
        ${unsafeHTML(code2)}

        <p>
          <a target="_blank" href="https://perspective.finos.org/docs/js/#perspective-viewer-web-component-library">Details
            on perspective can be found here.</a>
        </p>
      </cds-tile>
    `;
  }
}